import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import ImproveCoverageModal from "./ImproveCoverageModal";
const StyledButton = styled(Button)`
  align-self: center;

  @media print {
    display: none;
  }
`;
const ImproveCoverageButton = ({
  className = void 0,
  variant = void 0,
  coverageEntity = void 0,
  isTactic = void 0,
  initialStep = void 0
}) => {
  const sendTelemetry = useSendTelemetry();
  const [showCoverageModal, setShowCoverageModal] = useState(false);
  const openCoverageModal = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.THREAT_COVERAGE.IMPROVE_COVERAGE_EXPLANATION_OPENED, {
      app_pathname: "security",
      app_section: "threat-coverage"
    });
    setShowCoverageModal(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      bsStyle: "info",
      bsSize: variant === "large" ? void 0 : "xs",
      onClick: openCoverageModal,
      className
    },
    variant === "large" && /* @__PURE__ */ React.createElement(React.Fragment, null, "Improve threat coverage"),
    /* @__PURE__ */ React.createElement(Icon, { name: "deployed_code_update" })
  ), showCoverageModal && /* @__PURE__ */ React.createElement(
    ImproveCoverageModal,
    {
      onHide: () => setShowCoverageModal(false),
      isTactic,
      coverageEntity,
      initialStep
    }
  ));
};
export default ImproveCoverageButton;
